import Vue from 'vue'
import Element from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// 修改element主题颜色
import '@/assets/scss/element/element-variables.scss'

Vue.use(Element)
